import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import SliderComponent from './Slider';

// @TODO: Change this to fetch images from server
export default () => {
  const data = useStaticQuery(graphql`
    query {
      bride: file(relativePath: { eq: "brideslide1.png" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
      wedding: file(relativePath: { eq: "brideslide2.png" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp_noBase64
          }
        }
      }
    }
  `);
  // Mock data
  const content = [
    {
      title: 'Planeje seu casamento em um só lugar',
      subtitle: 'Com fornecedores de ',
      styledSubtitle: 'qualidade e confiança',
      text: 'Encontre fornecedores certificados:',
      backgroundImg: data.bride.childImageSharp.fluid,
    },
    {
      title: 'Planeje seu casamento em um só lugar',
      subtitle: 'Com fornecedores de ',
      styledSubtitle: 'qualidade e confiança',
      text: 'Encontre fornecedores certificados:',
      backgroundImg: data.wedding.childImageSharp.fluid,
    },
  ];

  return <SliderComponent content={content} />;
};
